import React, { useEffect, useState } from "react";
import { PageHero, CtaBanner } from "@/components/PageParts";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api } from "@/lib/api";

export default function Faqs() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/content/faqs").then((r) => setFaqs(r.data || [])); }, []);
  return (
    <div data-testid="page-faqs">
      <PageHero
        eyebrow="Frequently Asked Questions"
        title="Everything worth asking, gently answered."
        image="https://images.pexels.com/photos/8848784/pexels-photo-8848784.jpeg"
        testid="faqs-hero"
      />
      <section className="section-pad bg-offwhite">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f) => (
              <AccordionItem key={f.id} value={f.id} className="border-b border-border-warm" data-testid={`faq-${f.id}`}>
                <AccordionTrigger className="font-serif text-xl md:text-2xl text-left py-6 hover:no-underline text-headline">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-warmgrey text-base leading-relaxed pb-6">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
      <CtaBanner title="Still have a question?" subtitle="Send us a note and we'll come back to you personally." testid="faqs-cta" />
    </div>
  );
}
